module.exports = __webpack_public_path__ + "img/Calidad-N.a4a19748.png";